export default __webpack_public_path__ + "static/media/heavy-traffic-31.577afdf8.svg";